/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-01-20 13:33:30
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Stack, Button, Popover, ActionList, Icon } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { LockMinor } from '@shopify/polaris-icons';
import history from 'src/routes/history';
import { routes } from 'src/routes';
import ProcessAddon from 'src/components/views/subscription-v3/addon/process-addon';
import ProcessAddonV4 from 'src/components/views/subscription-v4/addon/process-addon';
import { ADDONS_INFO, ADDONS_INFO_V4, VISUAL_MERCHANDISING_NAME } from 'src/constants/subscription';

import { enterSABFullscreen } from 'src/integrations/shopify-app-bridge/fullscreen';

type Props = WithI18nProps & {
  total: number,
  showButtonSwitchBack: boolean,
  isNewRule: boolean,
  onSwitchBack: Function
};

class ActionsGroupOnListing extends Component<Props> {
  state = {
    active: false,
    modalAddon: false
  };
  render() {
    const { i18n, onSwitchBack, isNewRule, hasAddonMerchandising } = this.props;

    return (
      <Stack>
        {false && (
          <Button onClick={onSwitchBack}>
            {i18n.translate('AdminHTML.MerchandisingV2.Merchandising.backToOldVersion')}
          </Button>
        )}
        <div className={isNewRule && hasAddonMerchandising ? 'btn-highlight' : ''}>
          {this.renderPopoverAddNewRule()}
        </div>
      </Stack>
    );
  }

  // Render popover add new rule options
  renderPopoverAddNewRule = () => {
    const { i18n, hasAddonMerchandising, enabledSubscriptionV4, isSubscribeNow } = this.props;
    const { active, modalAddon } = this.state;
    const activator = (
      <Button primary onClick={() => this.toggleModal('active')}>
        {i18n.translate('AdminHTML.MerchandisingV2.Merchandising.newRule')}
      </Button>
    );

    return (
      <>
        <Popover active={active} activator={activator} onClose={() => this.toggleModal('active')}>
          <ActionList
            actionRole="menuitem"
            items={[
              {
                content: i18n.translate('AdminHTML.MerchandisingV2.Merchandising.tab_Content01'),
                onAction: () => this.openRulePage('search')
              },
              {
                content: (
                  <p className={!hasAddonMerchandising ? 'collection-action-locked' : ''}>
                    {i18n.translate('AdminHTML.MerchandisingV2.Merchandising.tab_Content02')}
                    {!hasAddonMerchandising && <Icon source={LockMinor} color="base" />}
                  </p>
                ),
                onAction: () => this.handleProcessCollectionPage()
              }
            ]}
          />
        </Popover>

        {enabledSubscriptionV4 ? (
          <ProcessAddonV4
            openModalReview={modalAddon}
            addon={ADDONS_INFO_V4.find(e => e.addonName === VISUAL_MERCHANDISING_NAME)}
            hadSubscribed={isSubscribeNow}
            handleAfterSubscribeAddon={this.handleCloseStatus}
            handleReviewModal={() => this.toggleModal('modalAddon')}
          />
        ) : (
          <ProcessAddon
            openModalReview={modalAddon}
            addon={ADDONS_INFO.find(e => e.addonName === VISUAL_MERCHANDISING_NAME)}
            hadSubscribed={isSubscribeNow}
            handleAfterSubscribeAddon={this.handleCloseStatus}
            handleReviewModal={() => this.toggleModal('modalAddon')}
          />
        )}
      </>
    );
  };

  // toggle modal
  toggleModal = fieldName => {
    const value = this.state[fieldName];
    this.setState({ [fieldName]: !value });
  };

  /** Subscribe addon - reload page after subscribe*/
  handleCloseStatus = () => {
    this.props.getAddonStatus(VISUAL_MERCHANDISING_NAME);
  };

  // process when click btn collection page
  handleProcessCollectionPage = () => {
    const { hasAddonMerchandising } = this.props;
    if (!hasAddonMerchandising) {
      this.setState({
        modalAddon: true,
        active: false
      });
      return;
    }
    this.openRulePage('collection');
  };

  // open rule page
  openRulePage = ruleType => {
    history.push(routes.merchandising.new(ruleType));
    enterSABFullscreen();
  };
}

export default withI18n()(ActionsGroupOnListing);
